export default __webpack_public_path__ + "static/email-67bda94140af311d041f7d2e23224f1f.png";